<h6>{{ sidebarItem?.title }}</h6>
<hr />
<div *ngFor="let sidebarItemChild of sidebarItemChildren">
  <a class="nav-link" routerLinkActive="active-sidebar-item-child" [routerLink]="[sidebarItem.path]">
    <span>
      {{ sidebarItem.title }}
    </span>
  </a>
</div>